export default [
   'assertedDate',
   'authoredOn',
   'created',
   'date',
   'dateAsserted',
   'dosageInstruction',
   'effectiveDateTime',
   'effectiveTimeDateTime',
   'effectiveTimePeriod',
   'onsetDateTime',
   'performedDateTime',
   'performedPeriod',
   'recordedDate',
   'whenHandedOver'
]
